<ion-app>
  <app-layout></app-layout>
</ion-app>
